import { SelectInput } from "@gettactic/components/src/form/SelectInput/SelectInput";
import { cn } from "@gettactic/helpers";
import React from "react";

export interface EditorSelectOption {
  value: string;
  label: string;
}

export interface EditorSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  options: EditorSelectOption[];
  /** Accessible name for the trigger. */
  label: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * The single inspector select: 28px trigger matching EditorField, built on
 * the shared SelectInput/UnifiedSelect. Replaces the native `<select>`
 * elements in the shape panels.
 */
export const EditorSelect: React.FC<EditorSelectProps> = ({
  value,
  onValueChange,
  options,
  label,
  placeholder,
  disabled,
  className
}) => {
  const items = React.useMemo(
    () =>
      options.map((option) => ({
        id: option.value,
        name: option.label
      })),
    [options]
  );

  return (
    <SelectInput
      aria-label={label}
      value={value}
      onChangeValue={onValueChange}
      items={items}
      placeholder={placeholder}
      disabled={disabled}
      inputClassName={cn(
        "h-7 min-h-0 rounded-md border-neutral-200 bg-background-primary px-2 py-0 text-neutral-900 text-xs",
        "hover:border-neutral-300 hover:bg-transparent",
        className
      )}
    />
  );
};
